import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromReducers from './portal-link.reducers';
import { PortalLinkState } from './portal-link.state';

export const selectPortalLinkState = createFeatureSelector<PortalLinkState>('app_launcher');

export const { selectIds, selectEntities, selectAll, selectTotal } = fromReducers.portalLinkAdapter.getSelectors(selectPortalLinkState);

export const selectIsLoading = createSelector(selectPortalLinkState, (state) => state.loading);

export const selectIsLoaded = createSelector(selectPortalLinkState, (state) => state.loaded);

export const selectAllEnabledPortalLinks = createSelector(selectAll, (portalLinks) => portalLinks.filter((pl) => pl.isEnabled));

export const selectFavorites = createSelector(selectAllEnabledPortalLinks, (portalLinks) =>
	portalLinks.filter((pl) => pl.isFavorite).sort((a, b) => a.favoriteOrderNumber - b.favoriteOrderNumber)
);

export const selectQuickLinks = createSelector(selectAll, (portalLinks) =>
	portalLinks.filter((pl) => !!pl.portalQuickLinkID).sort((a, b) => (a.quickLinkOrderNumber > b.quickLinkOrderNumber ? 1 : -1))
);
